import { useTranslation } from 'react-i18next';
import { InputControlled } from '@/components/form/input-controlled';
import { SelectControlled } from '@/components/form/select-controlled';
import { InputGroupAddon, InputGroupText } from '@/components/ui/input-group';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useCriteriaForm } from '../../hooks/use-criteria-form';
import { useCriteriaOptions } from '../../hooks/use-criteria-options';

type CriteriaFormProps = {
  lotSizingId: string;
};

export function CriteriaForm({ lotSizingId }: CriteriaFormProps) {
  const { t } = useTranslation(['common', 'lotSizing']);
  const { criteriaTypeOptions } = useCriteriaOptions();

  const {
    control,
    formState,
    containerSelectionOptions,
    canEditMaximumVolume,
    isDefaultContainerVolume,
    onVolumeMaximumChange,
  } = useCriteriaForm({ lotSizingId });

  return (
    <div>
      <div className='space-y-4'>
        <SelectControlled
          control={control}
          disabled
          error={formState.errors.contenantType?.message}
          label={t('lotSizing:type-of-container')}
          name='contenantType'
          options={criteriaTypeOptions}
          placeholder={t('lotSizing:choose-type-of-container')}
        />
        <SelectControlled
          control={control}
          disabled
          error={formState.errors.containerSelection?.message}
          label={t('lotSizing:container-size')}
          name='containerSelection'
          options={containerSelectionOptions}
          placeholder={t('lotSizing:container-size')}
        />
        <div className='flex w-full gap-2'>
          <div className='flex-1'>
            <InputControlled
              control={control}
              disabled={!canEditMaximumVolume}
              id='volume-maximum'
              label={t('lotSizing:volume-maximum')}
              name='volumeMaximum'
              onValueChange={onVolumeMaximumChange}
              placeholder={t('lotSizing:enter-volume')}
              type='number'
            >
              <InputGroupAddon align='inline-end'>
                <InputGroupText className='text-muted-foreground'>
                  m³
                </InputGroupText>
              </InputGroupAddon>
            </InputControlled>
          </div>
          <div className='flex items-center'>
            {isDefaultContainerVolume ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <button
                    className='flex size-5 items-center justify-center rounded-full bg-amber-600 font-semibold text-white text-xs leading-none'
                    type='button'
                  >
                    i
                  </button>
                </TooltipTrigger>
                <TooltipContent>
                  {t('lotSizing:volume-maximum-tooltip')}
                </TooltipContent>
              </Tooltip>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
